import React from 'react';
import LabeledEventAssignmentCount from './LabeledEventAssignmentCount';
import LabeledAppraisalAssignedCount from './LabeledAppraisalAssignedCount';
import AnimatedWrapper from '@shared/components/animations/AnimatedWrapper';

const ATL_LABEL = 'ATL';
const ATM_LABEL = 'ATM';
const TOTAL_LABEL = 'Total';

/**
 * @typedef {object} YtdAppraisalStatisticsProps
 * @property {Object} [appraiserNonEditableData]
 * @property {boolean} [appraiserInfoLoading]
 */

/**
 * @param {YtdAppraisalStatisticsProps} props
 */
const YtdAppraisalStatistics = props => {
  const { appraiserNonEditableData, appraiserInfoLoading } = props;
  const {
    atlTotalEvents,
    atmTotalEvents,
    atlTotalAppraisals,
    atmTotalAppraisals,
    totalEvents,
    atlObserverTotalEvents,
    atmObserverTotalEvents,
    isObserver
  } = appraiserNonEditableData;

  return (
    <>
      <div className='appraisals-statistics' data-testid='appraisals-delivered'>
        <p className='bold'>YTD Appraisals Delivered:</p>
        <LabeledAppraisalAssignedCount
          label={ATL_LABEL}
          text={atlTotalAppraisals}
          loading={appraiserInfoLoading}
        />
        <LabeledAppraisalAssignedCount
          label={ATM_LABEL}
          text={atmTotalAppraisals}
          loading={appraiserInfoLoading}
        />
      </div>
      <div className='appraisals-statistics' data-testid='appraisals-assigned'>
        <p className='bold'>YTD Appraisals Assigned:</p>
        <LabeledEventAssignmentCount
          label={ATL_LABEL}
          data={atlTotalEvents}
          loading={appraiserInfoLoading}
        />
        <LabeledEventAssignmentCount
          label={ATM_LABEL}
          data={atmTotalEvents}
          loading={appraiserInfoLoading}
        />
        <LabeledEventAssignmentCount
          label={TOTAL_LABEL}
          data={totalEvents}
          loading={appraiserInfoLoading}
        />
      </div>
      <AnimatedWrapper
        show={!!isObserver}
        className='appraisals-statistics'
        data-testid='observations-coaching'>
        <p className='bold'>Cumulative Observations and Coaching:</p>
        <LabeledAppraisalAssignedCount
          label={ATL_LABEL}
          loading={appraiserInfoLoading}
          text={atlObserverTotalEvents}
        />
        <LabeledAppraisalAssignedCount
          label={ATM_LABEL}
          loading={appraiserInfoLoading}
          text={atmObserverTotalEvents}
        />
      </AnimatedWrapper>
    </>
  );
};

export default YtdAppraisalStatistics;
